var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.12,
    height: 78.943,
    viewBox: "0 0 257.12 78.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo16",
    transform: "translate(-145.148 -5051.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M111-57.343h2.742V-74.059H111Z",
    transform: "translate(140.794 5152.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M126.157-64.989c0-2.429-1.323-3.679-3.32-3.679-2.02,0-3.343,1.251-3.343,3.679v7.408h-2.742V-70.833h2.742v1.515a5.094,5.094,0,0,1,3.944-1.732c3.1,0,5.438,1.947,5.438,5.653v7.817h-2.719Z",
    transform: "translate(141.248 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M131.6-68.372h-1.564v-2.237H131.6v-3.3h2.765v3.3h3.224v2.237h-3.224v7.336c0,.987.386,1.4,1.541,1.4h1.683v2.286h-2.165c-2.356,0-3.825-.987-3.825-3.682Z",
    transform: "translate(142.295 5152.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M141.263-65.4H148.6a3.439,3.439,0,0,0-3.7-3.343,3.608,3.608,0,0,0-3.633,3.343m3.752,8.035c-3.8,0-6.616-2.7-6.616-6.857s2.7-6.831,6.616-6.831a6.18,6.18,0,0,1,6.447,6.517,8.759,8.759,0,0,1-.1,1.349H141.24a3.645,3.645,0,0,0,3.775,3.511,3.212,3.212,0,0,0,3.128-1.851H151.1a6.055,6.055,0,0,1-6.085,4.161",
    transform: "translate(142.954 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M155.612-57.58H152.87V-70.835h2.742v1.926a4.311,4.311,0,0,1,3.969-2.141v2.838h-.7c-2.02,0-3.27.842-3.27,3.656Z",
    transform: "translate(144.095 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M170.7-64.989c0-2.429-1.323-3.679-3.319-3.679-2.02,0-3.343,1.251-3.343,3.679v7.408H161.3V-70.833h2.742v1.515a5.094,5.094,0,0,1,3.944-1.732c3.1,0,5.438,1.947,5.438,5.653v7.817H170.7Z",
    transform: "translate(144.76 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M181.616-68.669a4.066,4.066,0,0,0-4.016,4.4c0,2.864,1.971,4.524,4.016,4.524,2.069,0,4.019-1.613,4.019-4.474a4.111,4.111,0,0,0-4.019-4.451m-.578-2.382a5.646,5.646,0,0,1,4.6,2.141v-1.924H188.4v13.255h-2.765v-1.973a5.708,5.708,0,0,1-4.643,2.188c-3.441,0-6.207-2.815-6.207-6.9s2.765-6.784,6.253-6.784",
    transform: "translate(145.823 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M191.13-68.372h-1.564v-2.237h1.564v-3.3H193.9v3.3h3.224v2.237H193.9v7.336c0,.987.386,1.4,1.541,1.4h1.683v2.286h-2.165c-2.356,0-3.825-.987-3.825-3.682Z",
    transform: "translate(146.989 5152.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M198.8-70.466h2.742v13.255H198.8Zm-.36-3.511a1.734,1.734,0,0,1,1.756-1.756,1.729,1.729,0,0,1,1.732,1.756,1.729,1.729,0,0,1-1.732,1.756,1.734,1.734,0,0,1-1.756-1.756",
    transform: "translate(147.688 5152.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M210.341-59.745c2.045,0,4.065-1.468,4.065-4.474s-1.95-4.451-3.993-4.451c-2.069,0-3.923,1.445-3.923,4.451s1.782,4.474,3.85,4.474m0,2.382a6.464,6.464,0,0,1-6.639-6.857,6.536,6.536,0,0,1,6.761-6.831,6.536,6.536,0,0,1,6.758,6.831,6.64,6.64,0,0,1-6.88,6.857",
    transform: "translate(148.103 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M228.022-64.989c0-2.429-1.323-3.679-3.319-3.679-2.02,0-3.343,1.251-3.343,3.679v7.408h-2.742V-70.833h2.742v1.515A5.1,5.1,0,0,1,225.3-71.05c3.1,0,5.438,1.947,5.438,5.653v7.817h-2.719Z",
    transform: "translate(149.279 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M238.937-68.669a4.068,4.068,0,0,0-4.019,4.4c0,2.864,1.973,4.524,4.019,4.524,2.069,0,4.016-1.613,4.016-4.474a4.109,4.109,0,0,0-4.016-4.451m-.577-2.382a5.637,5.637,0,0,1,4.594,2.141v-1.924h2.768v13.255h-2.768v-1.973a5.7,5.7,0,0,1-4.643,2.188c-3.439,0-6.2-2.815-6.2-6.9s2.765-6.784,6.253-6.784",
    transform: "translate(150.343 5152.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M247.935-57.261h2.742v-17.8h-2.742Z",
    transform: "translate(151.591 5152.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M116.963-36.842c-3.343,0-5.917-1.828-5.917-4.788h2.934a2.683,2.683,0,0,0,2.983,2.478c1.924,0,3.006-1.033,3.006-2.452,0-4.042-8.876-1.419-8.876-7.579,0-2.934,2.333-4.762,5.751-4.762,3.2,0,5.458,1.683,5.7,4.547h-3.029a2.616,2.616,0,0,0-2.815-2.214c-1.587-.049-2.815.722-2.815,2.333,0,3.778,8.853,1.419,8.853,7.53,0,2.5-2.046,4.907-5.774,4.907",
    transform: "translate(140.798 5154.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M127.062-45.082H134.4a3.439,3.439,0,0,0-3.7-3.343,3.608,3.608,0,0,0-3.633,3.343m3.752,8.035c-3.8,0-6.616-2.693-6.616-6.857s2.7-6.831,6.616-6.831a6.181,6.181,0,0,1,6.447,6.517,8.445,8.445,0,0,1-.1,1.349H127.039a3.645,3.645,0,0,0,3.775,3.511,3.212,3.212,0,0,0,3.128-1.851h2.96a6.061,6.061,0,0,1-6.087,4.161",
    transform: "translate(141.835 5154.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M144.607-50.735c3.247,0,5.365,1.613,6.111,4.4h-2.96a3.1,3.1,0,0,0-3.151-2.092c-2.214,0-3.682,1.636-3.682,4.521,0,2.91,1.468,4.547,3.682,4.547a3.025,3.025,0,0,0,3.151-2.092h2.96a5.956,5.956,0,0,1-6.111,4.4c-3.8,0-6.494-2.693-6.494-6.857,0-4.135,2.693-6.831,6.494-6.831",
    transform: "translate(142.932 5154.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M164.5-37.28h-2.742v-1.587a4.938,4.938,0,0,1-3.92,1.779c-3.1,0-5.461-1.947-5.461-5.653v-7.794H155.1v7.385c0,2.431,1.323,3.682,3.32,3.682,2.02,0,3.343-1.251,3.343-3.682v-7.385H164.5Z",
    transform: "translate(144.057 5154.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M169.86-37.264h-2.742V-50.519h2.742v1.926a4.311,4.311,0,0,1,3.969-2.141V-47.9h-.7c-2.02,0-3.27.842-3.27,3.656Z",
    transform: "translate(145.219 5154.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M175.862-50.149H178.6v13.255h-2.742ZM175.5-53.66a1.734,1.734,0,0,1,1.756-1.756,1.729,1.729,0,0,1,1.732,1.756,1.729,1.729,0,0,1-1.732,1.756A1.734,1.734,0,0,1,175.5-53.66",
    transform: "translate(145.88 5153.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M182.391-48.055h-1.564v-2.237h1.564v-3.3h2.765v3.3h3.224v2.237h-3.224v7.336c0,.987.386,1.4,1.541,1.4h1.683v2.286h-2.165c-2.356,0-3.825-.987-3.825-3.682Z",
    transform: "translate(146.3 5154.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M190.351-50.149h2.742v13.255h-2.742Zm-.36-3.511a1.734,1.734,0,0,1,1.756-1.756,1.729,1.729,0,0,1,1.732,1.756,1.729,1.729,0,0,1-1.732,1.756,1.734,1.734,0,0,1-1.756-1.756",
    transform: "translate(147.022 5153.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M198.383-45.082h7.336a3.439,3.439,0,0,0-3.7-3.343,3.612,3.612,0,0,0-3.633,3.343m3.752,8.035c-3.8,0-6.616-2.693-6.616-6.857s2.7-6.831,6.616-6.831a6.181,6.181,0,0,1,6.448,6.517,8.447,8.447,0,0,1-.1,1.349H198.36a3.645,3.645,0,0,0,3.775,3.511,3.209,3.209,0,0,0,3.128-1.851h2.96a6.061,6.061,0,0,1-6.088,4.161",
    transform: "translate(147.458 5154.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M215.143-37.047c-3.175,0-5.412-1.877-5.533-4.283h2.84a2.415,2.415,0,0,0,2.646,1.973c1.587,0,2.429-.673,2.429-1.587,0-2.6-7.7-1.106-7.7-5.966,0-2.115,1.973-3.824,5.1-3.824,3.009,0,4.979,1.613,5.124,4.257h-2.742a2.19,2.19,0,0,0-2.475-1.947c-1.468,0-2.237.6-2.237,1.491,0,2.67,7.478,1.178,7.623,5.966,0,2.237-1.947,3.92-5.075,3.92",
    transform: "translate(148.569 5154.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M113.684-31.3a1.569,1.569,0,0,0-1.569,1.714,1.591,1.591,0,0,0,1.569,1.737,1.591,1.591,0,0,0,1.577-1.73,1.593,1.593,0,0,0-1.577-1.722m-.153-.668a1.931,1.931,0,0,1,1.73.922v-.847h.779v4.648h-.779v-.865a1.938,1.938,0,0,1-1.737.94,2.237,2.237,0,0,1-2.2-2.416,2.2,2.2,0,0,1,2.206-2.382",
    transform: "translate(140.82 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M120.31-29.874c0-.95-.518-1.434-1.3-1.434s-1.331.495-1.331,1.494v2.569h-.772v-4.645h.772v.66a1.714,1.714,0,0,1,1.491-.746,1.8,1.8,0,0,1,1.9,1.991v2.74h-.764Z",
    transform: "translate(141.26 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M124.042-27.159h.772v-5.911h-.772Z",
    transform: "translate(141.822 5155.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M129.759-29.838h-3.011v2.68h-.772v-5.911h.772v2.595h3.011v-2.595h.772v5.911h-.772Z",
    transform: "translate(141.975 5155.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M134.095-33.14a2.781,2.781,0,0,1,2.74,1.789h-.924a1.862,1.862,0,0,0-1.815-1.111,2.146,2.146,0,0,0-2.162,2.349,2.146,2.146,0,0,0,2.162,2.343,1.871,1.871,0,0,0,1.815-1.1h.924a2.78,2.78,0,0,1-2.74,1.771,2.9,2.9,0,0,1-2.952-3.011,2.914,2.914,0,0,1,2.952-3.027",
    transform: "translate(142.382 5155.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M141.579-31.969a2.021,2.021,0,0,1,2.147,1.569h-.834a1.265,1.265,0,0,0-1.313-.917c-.849,0-1.476.6-1.476,1.737,0,1.155.627,1.756,1.476,1.756a1.243,1.243,0,0,0,1.313-.914h.834a2.07,2.07,0,0,1-2.147,1.569,2.216,2.216,0,0,1-2.266-2.411,2.208,2.208,0,0,1,2.266-2.39",
    transform: "translate(143.027 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M146.4-27.847a1.578,1.578,0,0,0,1.6-1.73,1.562,1.562,0,0,0-1.569-1.722,1.541,1.541,0,0,0-1.554,1.722,1.532,1.532,0,0,0,1.528,1.73m0,.678a2.255,2.255,0,0,1-2.315-2.408,2.272,2.272,0,0,1,2.348-2.393,2.268,2.268,0,0,1,2.349,2.393,2.3,2.3,0,0,1-2.382,2.408",
    transform: "translate(143.403 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M156.1-29.874c0-.95-.508-1.434-1.271-1.434-.782,0-1.315.5-1.315,1.5v2.561h-.764v-2.628c0-.95-.51-1.434-1.271-1.434-.779,0-1.315.5-1.315,1.5v2.561h-.772v-4.645h.772v.668a1.68,1.68,0,0,1,1.468-.753,1.748,1.748,0,0,1,1.7,1.033,1.725,1.725,0,0,1,1.647-1.033,1.8,1.8,0,0,1,1.882,1.991v2.74H156.1Z",
    transform: "translate(143.821 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M159.838-31.3a1.6,1.6,0,0,0-1.577,1.722,1.594,1.594,0,0,0,1.577,1.73,1.592,1.592,0,0,0,1.577-1.737,1.57,1.57,0,0,0-1.577-1.714m.161-.668a2.2,2.2,0,0,1,2.206,2.382A2.237,2.237,0,0,1,160-27.17a2,2,0,0,1-1.737-.932v3.061h-.774v-6.851h.774v.857A1.962,1.962,0,0,1,160-31.968",
    transform: "translate(144.459 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M164.9-31.3a1.569,1.569,0,0,0-1.569,1.714,1.591,1.591,0,0,0,1.569,1.737,1.591,1.591,0,0,0,1.577-1.73A1.593,1.593,0,0,0,164.9-31.3m-.153-.668a1.931,1.931,0,0,1,1.73.922v-.847h.779v4.648h-.779v-.865a1.941,1.941,0,0,1-1.737.94,2.237,2.237,0,0,1-2.2-2.416,2.2,2.2,0,0,1,2.206-2.382",
    transform: "translate(144.858 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M171.522-29.874c0-.95-.518-1.434-1.3-1.434s-1.331.495-1.331,1.494v2.569h-.774v-4.645h.774v.66a1.711,1.711,0,0,1,1.491-.746,1.8,1.8,0,0,1,1.9,1.991v2.74h-.764Z",
    transform: "translate(145.298 5155.841)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M176.4-31.9h.8l-2.8,6.836h-.8l.917-2.24-1.875-4.6h.857l1.458,3.765Z",
    transform: "translate(145.654 5155.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M23.487-50.621a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(133.591 5154.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M33.616-56.558a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(134.389 5153.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M23.487-62.27a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(133.591 5153.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M33.616-68.208a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(134.389 5152.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M74.138-56.546A3.847,3.847,0,0,0,70.29-52.7a3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(137.584 5153.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M63.8-62.416a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85A3.847,3.847,0,0,0,63.8-62.416",
    transform: "translate(136.769 5153.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M63.8-74.065a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85A3.847,3.847,0,0,0,63.8-74.065",
    transform: "translate(136.769 5152.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M84.267-50.609a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(138.383 5154.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M84.267-62.259a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(138.383 5153.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M74.138-68.2a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85A3.847,3.847,0,0,0,74.138-68.2",
    transform: "translate(137.584 5152.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M43.958-62.427A3.847,3.847,0,0,0,40.11-58.58a3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(135.205 5153.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M43.958-74.077a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(135.205 5152.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M53.817-80.045A3.847,3.847,0,0,0,49.969-76.2a3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(135.982 5152.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M53.817-68.424a3.847,3.847,0,0,0-3.848,3.848,3.849,3.849,0,0,0,3.848,3.85,3.849,3.849,0,0,0,3.848-3.85,3.847,3.847,0,0,0-3.848-3.848",
    transform: "translate(135.982 5152.967)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M67.564-30.184a1.29,1.29,0,0,0-1.289,1.289,1.289,1.289,0,0,0,1.289,1.287,1.289,1.289,0,0,0,1.289-1.287,1.29,1.29,0,0,0-1.289-1.289m12.447,5.653a1.29,1.29,0,0,0-1.289,1.289,1.287,1.287,0,0,0,1.289,1.287A1.287,1.287,0,0,0,81.3-23.242a1.289,1.289,0,0,0-1.287-1.289m-23.213,0a1.289,1.289,0,0,0-1.287,1.289A1.287,1.287,0,0,0,56.8-21.955a1.287,1.287,0,0,0,1.289-1.287A1.29,1.29,0,0,0,56.8-24.531M67.236-90.966a1.287,1.287,0,0,0,1.287,1.287,1.287,1.287,0,0,0,1.289-1.287,1.29,1.29,0,0,0-1.289-1.289,1.289,1.289,0,0,0-1.287,1.289m11.157,6.517a1.289,1.289,0,0,0,1.287,1.287,1.289,1.289,0,0,0,1.289-1.287,1.29,1.29,0,0,0-1.289-1.289,1.289,1.289,0,0,0-1.287,1.289m10.927,6.38a1.29,1.29,0,0,0,1.289,1.289A1.289,1.289,0,0,0,91.9-78.068a1.289,1.289,0,0,0-1.287-1.287,1.289,1.289,0,0,0-1.289,1.287m-77.172,53.4a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.289,1.289,0,0,0-1.289-1.287,1.287,1.287,0,0,0-1.287,1.287m0-12.582a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287m0-12.141A1.287,1.287,0,0,0,13.435-48.1a1.29,1.29,0,0,0,1.289-1.289,1.289,1.289,0,0,0-1.289-1.287,1.287,1.287,0,0,0-1.287,1.287m0-10.482a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287m0-11.16a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287M99.561-24.663a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.289,1.289,0,0,0-1.289-1.287,1.287,1.287,0,0,0-1.287,1.287m0-12.582a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287m0-12.141a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.289,1.289,0,0,0-1.289-1.287,1.287,1.287,0,0,0-1.287,1.287m0-10.482a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287m0-11.16a1.287,1.287,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287,1.285,1.285,0,0,0-1.287,1.287M56.8-98.721a1.289,1.289,0,0,0-1.287,1.289A1.287,1.287,0,0,0,56.8-96.145a1.287,1.287,0,0,0,1.289-1.287A1.29,1.29,0,0,0,56.8-98.721M46.164-92.89A1.287,1.287,0,0,0,44.874-91.6a1.29,1.29,0,0,0,1.289,1.289A1.289,1.289,0,0,0,47.451-91.6a1.287,1.287,0,0,0-1.287-1.287M35.006-86.538a1.289,1.289,0,0,0-1.289,1.287,1.29,1.29,0,0,0,1.289,1.289,1.289,1.289,0,0,0,1.287-1.289,1.289,1.289,0,0,0-1.287-1.287M24.077-79.86a1.287,1.287,0,0,0-1.287,1.287,1.289,1.289,0,0,0,1.287,1.289,1.29,1.29,0,0,0,1.289-1.289,1.287,1.287,0,0,0-1.289-1.287m10.93,55.329a1.29,1.29,0,0,0-1.289,1.289,1.287,1.287,0,0,0,1.289,1.287,1.287,1.287,0,0,0,1.287-1.287,1.289,1.289,0,0,0-1.287-1.289m11.157-5.653a1.29,1.29,0,0,0-1.289,1.289,1.289,1.289,0,0,0,1.289,1.287,1.289,1.289,0,0,0,1.287-1.287,1.289,1.289,0,0,0-1.287-1.289M56.8-37.846a1.287,1.287,0,0,0-1.287,1.287A1.289,1.289,0,0,0,56.8-35.269a1.29,1.29,0,0,0,1.289-1.289A1.287,1.287,0,0,0,56.8-37.846m0-13.6a2.073,2.073,0,0,0-2.071,2.074A2.071,2.071,0,0,0,56.8-47.3a2.072,2.072,0,0,0,2.074-2.074A2.074,2.074,0,0,0,56.8-51.447M46.164-45.041a2.074,2.074,0,0,0-2.074,2.074,2.074,2.074,0,0,0,2.074,2.074,2.075,2.075,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074M80.8-36.559a2.075,2.075,0,0,0-2.074-2.074,2.075,2.075,0,0,0-2.074,2.074,2.074,2.074,0,0,0,2.074,2.074A2.074,2.074,0,0,0,80.8-36.559m8.853,4.192a2.075,2.075,0,0,0-2.074,2.074,2.075,2.075,0,0,0,2.074,2.074,2.075,2.075,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074M67.564-45.054A2.075,2.075,0,0,0,65.49-42.98a2.075,2.075,0,0,0,2.074,2.074,2.075,2.075,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074m11.157-27.6A2.073,2.073,0,0,0,80.8-74.723,2.074,2.074,0,0,0,78.722-76.8a2.074,2.074,0,0,0-2.074,2.074,2.073,2.073,0,0,0,2.074,2.071M56.8-85.251a2.071,2.071,0,0,0,2.074-2.071A2.072,2.072,0,0,0,56.8-89.4a2.071,2.071,0,0,0-2.071,2.074A2.071,2.071,0,0,0,56.8-85.251m-21.792,12.6a2.071,2.071,0,0,0,2.071-2.071A2.071,2.071,0,0,0,35.006-76.8a2.072,2.072,0,0,0-2.074,2.074,2.071,2.071,0,0,0,2.074,2.071M46.164-78.9a2.074,2.074,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074,2.074,2.074,0,0,0-2.074,2.074A2.072,2.072,0,0,0,46.164-78.9m21.4,0a2.074,2.074,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074,2.075,2.075,0,0,0-2.074,2.074A2.074,2.074,0,0,0,67.564-78.9M89.649-66.212a2.075,2.075,0,0,0,2.074-2.074,2.075,2.075,0,0,0-2.074-2.074,2.075,2.075,0,0,0-2.074,2.074,2.075,2.075,0,0,0,2.074,2.074M24.077-66.2a2.074,2.074,0,0,0,2.074-2.074,2.074,2.074,0,0,0-2.074-2.074,2.073,2.073,0,0,0-2.071,2.074A2.073,2.073,0,0,0,24.077-66.2m10.93,27.566a2.074,2.074,0,0,0-2.074,2.074,2.072,2.072,0,0,0,2.074,2.074,2.071,2.071,0,0,0,2.071-2.074,2.073,2.073,0,0,0-2.071-2.074m-10.93,6.266a2.073,2.073,0,0,0-2.071,2.074,2.073,2.073,0,0,0,2.071,2.074,2.074,2.074,0,0,0,2.074-2.074,2.074,2.074,0,0,0-2.074-2.074",
    transform: "translate(133 5150.578)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient16);
export default __webpack_public_path__ + "static/media/client16.8ecf7a364b08b67df720da08ff51a427.svg";
export { ForwardRef as ReactComponent };